<template>
  <section>
    <b-card v-for="chart in charts" :key="chart.userChartId">
      <h5><b-btn @click="remove(chart.userChartId)" variant="danger" size="sm"><font-awesome-icon icon="times" /></b-btn> {{ chart.name }}</h5>
      <line-chart v-if="chart.chartType=='line'" :filter="filter(chart)" loading="silent"></line-chart>
      <column-chart v-if="chart.chartType=='column'" :filter="filter(chart)" loading="silent"></column-chart>
      <carpet-chart v-if="chart.chartType=='carpet'" :filter="filter(chart)" loading="silent"></carpet-chart>
      <pie-chart v-if="chart.chartType=='pie'" :filter="filter(chart)" loading="silent"></pie-chart>
      <scatter-chart v-if="chart.chartType=='scatter'" :filter="filter(chart)" loading="silent"></scatter-chart>
      <radar-chart v-if="chart.chartType=='radar'" :filter="filter(chart)" loading="silent"></radar-chart>
    </b-card>
  </section>
</template>

<script>
import LineChart from '../../Charts/Types/Apex/Line'
import ColumnChart from '../../Charts/Types/Apex/Column'
import CarpetChart from '../../Charts/Types/Apex/Carpet'
import PieChart from '../../Charts/Types/Apex/Pie'
import ScatterChart from '../../Charts/Types/Apex/Scatter'
import RadarChart from '../../Charts/Types/Apex/Radar'

export default {
  name: "DashboardCharts",
  props: [ 'fromMonth', 'toMonth' ],
  components: { LineChart, ColumnChart, CarpetChart, PieChart, ScatterChart, RadarChart },

  created() {

  },

  methods: {
    filter(chart) {
      let filter = {
        channels: chart.channels,
        parameters: chart.parameter,
        sampling: chart.sampling,
        split: chart.split
      }
      if(chart.sampling == "m") {
        filter.fromMonth = this.fromMonth.format('MM-YYYY')
        filter.toMonth = this.toMonth.format('MM-YYYY')
      } else {
        filter.fromDate = this.fromMonth
        filter.toDate = this.toMonth
      }
      return filter
    },
    remove(id) {
      this.$store.dispatch('charts/deleteChart', id).then( (response) => {
        this.$store.dispatch('loadUser')
      })
    }
  },

  computed: {
    charts() {
      return this.$store.state.user.charts.filter(c => c.dashboard)
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Charts/Charts.vue